import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=cc8741f2&scoped=true&"
import script from "./ready.vue?vue&type=script&lang=js&"
export * from "./ready.vue?vue&type=script&lang=js&"
import style0 from "./ready.vue?vue&type=style&index=0&id=cc8741f2&prod&lang=less&"
import style1 from "./ready.vue?vue&type=style&index=1&id=cc8741f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8741f2",
  null
  
)

export default component.exports